import { StyleSheet, Text, View } from "react-native";
import React from "react";
import Layout from "~components/atoms/Layout/index.web";

const Dashboard = () => {
  return (
    <Layout>
      <Text>Dashboard</Text>
    </Layout>
  );
};

export default Dashboard;

const styles = StyleSheet.create({});
